import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { Manuscript } from '../../../models/manuscript';
import { ManuscriptsService } from '../../../services/manuscripts.service';
import { MsImageFileList } from '../../../models/ms-image-file';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-page-manuscript-card',
  templateUrl: './page-manuscript-card.component.html',
  styleUrls: ['./page-manuscript-card.component.css']
})
export class PageManuscriptCardComponent implements OnInit, OnDestroy {
    private subscriptions: Array<ISubscription> = [];
    manuscript: Manuscript; // current manuscript data
    expandedImage = false; // current image expansion status
    publicImageFiles: MsImageFileList; // current manuscript public images

    constructor(
        private activeRoute: ActivatedRoute,
        private manuscriptsService: ManuscriptsService ) {
    }

    ngOnInit() {
        this.activeRoute.params.subscribe(
            params => {
                if (params['manId']) {
                    this.subscriptions.push(
                        this.manuscriptsService.getManuscript(<number> params['manId'])
                            .subscribe(
                                response => this.manuscript = response,
                                err => console.error(err)
                            ),
                        this.manuscriptsService.getManuscriptImageFiles()
                            .subscribe(
                                response => this.publicImageFiles = response,
                                err => console.error(err)
                            )
                    );
                }
            }
        );
    }

    toggleImageExpansion() {
        this.expandedImage = !this.expandedImage;
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/pages/page-manuscript-card/page-manuscript-card.component.ts